import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; //element-ui的css
import App from '@/App';
import router from '@/router'; // api: https://github.com/vuejs/vue-router
import store from '@/store'; // api: https://github.com/vuejs/vuex
import VueCookie from 'vue-cookie'; // api: https://github.com/alfhen/vue-cookie
import '@/icons'; // api: http://www.iconfont.cn/
import '@/assets/element-ui-theme/style.css';
import Avue from '@smallwei/avue'; // api: https://avue.top
import '@smallwei/avue/lib/index.css';
import '@/assets/scss/index.scss';
import '@/styles/index.scss';
import '@/styles/public.scss';
import httpRequest from '@/utils/httpRequest'; // api: https://github.com/axios/axios
import { isAuth } from '@/utils';
import { loading } from '@/utils/loading';
import Print from 'vue-print-nb';
import dayjs from 'dayjs';
import BigNumber from 'bignumber.js';
import { footerMethodReduce } from '@/utils/index';
import { handleExportExcel } from '@/utils/index';

Vue.prototype.$bigNumber = BigNumber;
Vue.prototype.$dayjs = dayjs;
Vue.prototype.footerMethodReduce = footerMethodReduce;
Vue.prototype.handleExportExcel = handleExportExcel;
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
Vue.use(preview);
/*全量引用vxe**/
import VxeUIAll from 'vxe-pc-ui';
import 'vxe-pc-ui/lib/style.css';
Vue.use(VxeUIAll);
/** 全局设置vxe层级*/
import domZIndex from 'dom-zindex';
domZIndex.setCurrent(2099);
/*end**/
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import back from '@/components/back/back.vue';
import { Message } from 'element-ui';
Vue.component(back.name, back);
Vue.use(VXETable);
// 基于 element-ui 的数据驱动表单组件 https://www.yuque.com/chaojie-vjiel/vbwzgu/twp49o
import EleForm from 'vue-ele-form';
Vue.use(EleForm);
// import cloneDeep from 'lodash/cloneDeep'
Vue.use(Print);
Vue.use(Avue);
Vue.use(VueCookie);
Vue.use(ElementUI);
Vue.config.productionTip = false;

import oneMessage from './utils/oneMessage';
Vue.prototype.$message = oneMessage;
Vue.prototype.$XPrint = VXETable.print;
// 输出版本号
console.log('build time:1.01', process.env.APP_VERSION);
// 挂载全局
Vue.prototype.$http = httpRequest; // ajax请求方法
Vue.prototype.isAuth = isAuth; // 权限方法
Vue.prototype.$elmloading = loading; // 全局loading

['success', 'warning', 'info', 'error'].forEach((type) => {
  ElementUI.Message[type] = (options) => {
    if (typeof options === 'string') {
      options = {
        message: options
      };
      options.duration = 1000 * 5;
      // if (type == 'warning' || type == 'error') {
      //     options.showClose = true
      // }
    }
    options.type = type;
    return ElementUI.Message(options);
  };
});

// 保存整站vuex本地储存初始状态
// process.env.VUE_APP_RESOURCES_URL['storeState'] = cloneDeep(store.state)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
});
